import i18n from '../language/index'
import Cookies from 'js-cookie'

export const validWebsite = (rule, value, callback) => {
  if (value === '' || value === undefined) {
    callback()
  } else {
    const reg = /(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?/
    if (!reg.test(value)) { callback(new Error(i18n.t('base_valid_1945'))) } else {
      callback()
    }
  }
}
export const validRequiredWebsite = (rule, value, callback) => {
  if (value === '' || value === undefined) {
    callback(new Error(i18n.t('base_valid_1946')))
  } else {
    const reg = /(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?/
    if (!reg.test(value)) { callback(new Error(i18n.t('base_valid_1945'))) } else {
      callback()
    }
  }
}

export const validMobile = (rule, value, callback) => {
  if (value === '' || value === undefined) {
    callback(new Error(i18n.t('view_login_index_48')))
  } else {
    const reg = /[0-9]{11}/
    if (!reg.test(value)) { callback(new Error(i18n.t('view_login_index_49'))) } else {
      callback()
    }
  }
}

export const validID = (rule, value, callback) => {
  if (value === '' || value === undefined) {
    callback(new Error(i18n.t('base_valid_1947')))
  } else {
    const reg = /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
    if (!reg.test(value)) { callback(new Error(i18n.t('base_valid_1948'))) } else {
      callback()
    }
  }
}

export const phoneValid = value => {
  const reg = /[0-9]{11}/
  if (!reg.test(value)) {
    return false
  } else {
    return true
  }
}

//校验身份证号码
export function validateIDCard(value) {
  var format = /^(([1][1-5])|([2][1-3])|([3][1-7])|([4][1-6])|([5][0-4])|([6][1-5])|([7][1])|([8][1-2]))\d{4}(([1][9]\d{2})|([2]\d{3}))(([0][1-9])|([1][0-2]))(([0][1-9])|([1-2][0-9])|([3][0-1]))\d{3}[0-9xX]$/;
  //号码规则校验
  if (!format.test(value)) {
    return false;
  }
  //区位码校验
  //出生年月日校验   前正则限制起始年份为1900;
  var year = value.substr(6, 4), //身份证年
    month = value.substr(10, 2), //身份证月
    date = value.substr(12, 2), //身份证日
    time = Date.parse(month + "-" + date + "-" + year), //身份证日期时间戳date
    now_time = Date.parse(new Date()), //当前时间戳
    dates = new Date(year, month, 0).getDate(); //身份证当月天数
  if (time > now_time || date > dates) {
    return false;
  }
  //校验码判断
  var c = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]; //系数
  var b = ["1", "0", "X", "9", "8", "7", "6", "5", "4", "3", "2"]; //校验码对照表
  var id_array = value.split("");
  var sum = 0;
  for (var k = 0; k < 17; k++) {
    sum += parseInt(id_array[k]) * parseInt(c[k]);
  }
  return id_array[17].toUpperCase() === b[sum % 11].toUpperCase();
}

// 静态文件验证
export const staticRule = (rule, value, callback) => {
  if (!value) callback();
  var reg = /^[A-Za-z0-9_-]{1,80}$/;
  if (!reg.test(value)) {
    callback(i18n.t('base_valid_1949'))
  } else callback()
}


// 中文验证
export const chineseRule = (rule, value, callback,num=30) => {
  if(typeof num !== 'number') {
    num = 30
  }
  let zhText = ''
  let msg = i18n.t('base_valid_1950')
  if(typeof rule.field === 'string' && rule.field.indexOf("custom_attr.") != -1 ){
    msg = i18n.t('base_valid_1951');// 产品自定义属性
  }
  console.log('rule.field', rule)
  const site_language = Cookies.get("languageTypeNew_wm") || 'en-us'
  if (!value) callback();
  var reg = /[\u4e00-\u9fa5]/g;
  if (reg.test(value) && site_language == 'en-us') {
    var arr =  value.match(reg);
    var arrlast = arr.filter((item,index) =>{
      return arr.indexOf(item,0) === index;
    });
    zhText = arrlast.join("")
    callback(msg+`${zhText.length > num ? zhText.substring(0,num) + '...' : zhText}`)
  } else callback()
}

export const checkChineseRule  = ( value )  => {
  let zhText = ''
  let msg = i18n.t('base_valid_1950')
  const site_language = Cookies.get("languageTypeNew_wm") || 'en-us'
  var reg = /[\u4e00-\u9fa5]/g;
  if (reg.test(value) && site_language == 'en-us') {
    var arr =  value.match(reg);
    var arrlast = arr.filter((item,index) =>{
      return arr.indexOf(item,0) === index;
    });
    zhText = arrlast.join("")
    return  msg+`${zhText.length > 40 ? zhText.substring(0,40) + '...' : zhText}`
  }
  return '';
}

export const isNull = ( str )  => {
  if ( str == "" ) return true;
  if ( str == null ) return true;
  var regu = "^[ ]+$";
  var re = new RegExp(regu);
  return re.test(str);
}



// WEBPACK FOOTER //
// ./src/base/valid.js